import { isDefaultOpinionBubbleEventType } from './buildBubbleEventFromChartRenderEventList';

export function getOpinionEventOnlyOneKey(item: {
  event_type?: string;
  name?: string;
  start_time?: string;
  url?: string;
}): string {
  return `${item.event_type}$${item.name}$${item.start_time}$${item.url}`;
}

/** 按图表当前 bubbleEvent 回填设置弹窗勾选；无 bubbleEvent 时按舆情默认类型勾选 */
export function buildEventSettingSelectValue(
  data: Record<string, any[]> = {},
  bubbleEvent: Record<string, any[]> = {},
): Record<string, string[]> {
  const displayedKeys = new Set(
    Object.values(bubbleEvent || {})
      .flat()
      .filter(Boolean)
      .map((item: any) => getOpinionEventOnlyOneKey(item)),
  );
  const hasDisplayedEvents = displayedKeys.size > 0;
  const selected: Record<string, string[]> = {};

  Object.keys(data || {}).forEach(key => {
    const list = data[key] || [];
    const children = list.map((item: any) => getOpinionEventOnlyOneKey(item));

    if (hasDisplayedEvents) {
      selected[key] = children.filter(itemKey => displayedKeys.has(itemKey));
      return;
    }

    selected[key] = isDefaultOpinionBubbleEventType(key) ? children : [];
  });

  return selected;
}
